// Select all elements with the class '.product__variants__item'
var variantItems = document.querySelectorAll('.product__variants__item');

// Add a click event listener to each variant item
variantItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      console.log('this one', e.target);
        var variant = {
            id: this.getAttribute('data-id'), // Assuming the variant ID is stored in a data attribute
            title: this.getAttribute('data-title'), // Similarly for title, adjust if necessary
            inventory_quantity: this.getAttribute('data-quantity'),
            inventory_policy: this.getAttribute('data-policy')
        };

        // Dispatching the event on the body element
        document.body.dispatchEvent(new CustomEvent('variantChange', {
            detail: {
                variant: variant
            },
            bubbles: true,
            cancelable: true
        }));
      console.log('clicked variant')
      removeUrlParams();
      
    });
});
// Listen for the 'variantChange' event on the body element
document.body.addEventListener('variantChange', function(e) {
    var variant = e.detail.variant;
    console.log('Variant clicked:', variant);
        
});

function removeUrlParams() {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete('variant'); // Remove the variant parameter
  // Check if there are any parameters left
  const newQueryString = queryParams.toString();
  const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
  
  // Update the URL without reloading the page
  history.pushState(null, '', newUrl);
}
document.addEventListener('DOMContentLoaded', (event) => {
    const widthElements = document.querySelectorAll('.product__variants__width');
    const sizeElements = document.querySelectorAll('.product__variants__item');
    const productBtnTextElement = document.querySelector('.product__btn-text');
    const preBox = document.querySelector('.preorderbox');
    var addButton = document.querySelector('.product__btn-text');
    var qtyShow = document.querySelector('.data-qty-info');
    var sizeQty = document.querySelector('.size-qty');
    var submitButton = document.querySelector('.product-form__submit');
    var variantId = document.querySelector('.variant_id_input');
    var productHandle = addButton.getAttribute("data-product-handle");

    let lastSelectedSize = document.querySelector('.product__variants__item.current');
    
    function urlParms() {
      const queryParams = new URLSearchParams(window.location.search);
      const variantId = queryParams.get('variant');
      console.log(variantId, 'url variant id');
      if (!variantId) {
          console.log('No variant ID present in the URL.');
          return;
      }  
      document.querySelectorAll('.product__variants__item.current').forEach((element) => {
          element.classList.remove('current');
      });
  
      const variantElement = document.querySelector(`li[data-id="${variantId}"]`);
      if (variantElement) {
          variantElement.classList.add('current');
      }
    }

    function removeUrlParams() {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.delete('variant'); // Remove the variant parameter
      // Check if there are any parameters left
      const newQueryString = queryParams.toString();
      const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
      
      // Update the URL without reloading the page
      history.pushState(null, '', newUrl);
    }


function highlightVariant() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const variantUrlId = urlSearchParams.get('variant');
  console.log('Variant URL ID:', variantUrlId);
  if (!variantUrlId) {
    console.log('No variant ID provided in URL.');
    return; // Exit if no variant ID is provided
  }

  // Find all variant items on the page
  const variantItems = document.querySelectorAll('.product__variants__item');
  
  // Initially remove 'current' class only from the matching variant ID item
  let targetDataGroup = null;
  variantItems.forEach(item => {
    if (item.dataset.id === variantUrlId) {
      console.log(`Removing 'current' class from item with dataset.id: ${item.dataset.id}`);
      item.classList.remove('current');
      targetDataGroup = item.dataset.group; // Capture the data-group of the matching item
    }
  });

  // Check if targetDataGroup is found; if not, exit the function
  if (!targetDataGroup) {
    console.log('No matching data group found.');
    return;
  }
  
  console.log(`Target data group found: ${targetDataGroup}`);

  // Re-iterate over the items to add 'current' class to a different item with the same data-group
  let newDataId = null;
  for (let item of variantItems) {
    if (item.dataset.group === targetDataGroup && item.dataset.id !== variantUrlId) {
      item.classList.add('current');
      newDataId = item.dataset.id; // Use the data-id of this new matching item
      console.log(`'current' class added to a different item with new data ID: ${newDataId}`);
      break; // Exit the loop after finding the first eligible item
    }
  }

  // Proceed if a new variant ID was identified and it's different from the initial one
  if (newDataId) {
    console.log(newDataId, 'new data id')
      document.querySelectorAll('.product-form__buttons [data-cart-add], .variant_id_input').forEach(element => {
      if (element.tagName === 'INPUT') {
        element.value = newDataId; // Update the hidden input value
      } else {
        element.setAttribute('data-cart-add', newDataId); // Update the data-cart-add attribute
      }
    });

    // Update the 'variant' URL parameter with the new variant ID, preserving other parameters
    urlSearchParams.set('variant', newDataId);
    const newUrl = window.location.pathname + '?' + urlSearchParams.toString();
    window.history.pushState({ path: newUrl }, '', newUrl); // Update the browser URL without reloading the page
    console.log('Browser URL updated.');
  } else {
    console.log('No eligible new variant found to update.');
  }
}


    function updatePreOrderStatus() {
        const currentSizeElement = document.querySelector('.product__variants__item.current');
        console.log(currentSizeElement, 'currentSize landing');
        if (currentSizeElement) {
            const inventoryPolicy = currentSizeElement.getAttribute('data-policy');
            const inventoryQuantity = parseInt(currentSizeElement.getAttribute('data-quantity'), 10);
            var currentVariant = currentSizeElement.dataset.id;
            submitButton.setAttribute('data-cart-add', currentVariant);
            addButton.setAttribute('data-cart-add', currentVariant);
            variantId.value = currentVariant;
            console.log(currentVariant,'currentVariant inner');
            

            if (inventoryPolicy === 'continue' && inventoryQuantity <= 0) {
                preBox.style.display = 'flex';
                addButton.innerHTML = addButton.getAttribute("data-preorder-text");
                qtyShow.innerHTML = inventoryQuantity;
             	sizeQty.style.display = 'none';
            } else {
                preBox.style.display = 'none';
                addButton.innerHTML = addButton.getAttribute("data-add-to-cart-text");
                qtyShow.innerHTML = inventoryQuantity;
            } // else ends

          if ( inventoryQuantity <= 0 || inventoryQuantity >= 10 ){
             	sizeQty.style.display = 'none';
             } 
              else {
                sizeQty.style.display = 'flex';
              } // size else ends

        }
    }

    function filterSizes(selectedWidth) {
        if (selectedWidth !== 'Wide' && selectedWidth !== 'Standard') {
            return; // Exit if selected width is neither 'Wide' nor 'Standard'
        }
      

        let foundMatchingSize = false;

        sizeElements.forEach(function(sizeElement) {
            const sizeWidth = sizeElement.dataset.width;
            const sizeValue = sizeElement.dataset.group; // Assuming size is stored in data-group
            if (sizeWidth !== 'Wide' && sizeWidth !== 'Standard') {
              return; // Skip this iteration if sizeWidth is not 'Wide' or 'Standard'
            }
            if (sizeWidth === selectedWidth) {
                sizeElement.style.display = 'flex';
                // Check if this element matches the last selected size
                if (sizeValue === lastSelectedSize) {
                    sizeElement.classList.add('current');
                    urlParms();
                    updatePreOrderStatus();
                    foundMatchingSize = true;
                }
            } else {
                sizeElement.style.display = 'none';
                sizeElement.classList.remove('current');
            }
        });

        if (!foundMatchingSize && lastSelectedSize) {
            let firstSizeElement = document.querySelector(`.product__variants__item[data-width="${selectedWidth}"]`);
            if (firstSizeElement) {
                firstSizeElement.classList.add('current');
                lastSelectedSize = firstSizeElement.dataset.group;
                console.log(lastSelectedSize, 'last selected firstSize');
                urlParms();
                updatePreOrderStatus();
            }
        }
    }

    sizeElements.forEach(function(sizeElement) {
        sizeElement.addEventListener('click', function() {
            sizeElements.forEach(el => el.classList.remove('current'));
            this.classList.add('current');
            lastSelectedSize = this.dataset.group;
            console.log(lastSelectedSize, 'lastselected');
            urlParms();
            updatePreOrderStatus();
        });
    });

    widthElements.forEach(function(widthElement) {
        widthElement.addEventListener('click', function() {
          const selectedWidth = this.dataset.width;
          filterSizes(selectedWidth);
          // lastSelectedSize = this.dataset.group;
          highlightVariant();
        })
    });

    // Initial setup - show 'Standard' sizes and select the first size
    filterSizes('Standard');
    let firstStandardSizeElement = document.querySelector('.product__variants__item[data-width="Standard"]');
    if (firstStandardSizeElement) {
        firstStandardSizeElement.classList.add('current');
        urlParms();
        updatePreOrderStatus();
    }
    
    // Select all list items within the 'product-width-wrapper' class
    var widthItems = document.querySelectorAll('.product-width-wrapper .product__variants__width');
    
    // Add a click event listener to each list item
    widthItems.forEach(function(item) {
        item.addEventListener('click', function() {
            // Remove 'current' class from all items
            widthItems.forEach(function(innerItem) {
                innerItem.classList.remove('current');
            });
    
            // Add 'current' class to the clicked item
            this.classList.add('current');
        });
    });
});

// code to auto select the variant attributes based on the variant id in the query string
document.addEventListener('DOMContentLoaded', (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const variant = urlParams.get('variant');
    if( variant ) {
      const sizeItem = document.querySelector(`[data-id="${variant}"]`);
      const width = sizeItem.dataset.width;
      const widthItem = document.querySelector(`ul.product-width-wrapper li[data-width="${width}"`);
      widthItem.click();
      setTimeout(() => {
          sizeItem.click();
      }, 0);
    }
});


